import Heading from './Heading';
import Paragraph from './Paragraph';

export const Text = {
  Heading,
  Paragraph,
};

export default Text;
